import { Loader2 } from "lucide-react";

interface LoadingButtonContentProps {
    loading: boolean;
    children: React.ReactNode;
}

export function LoadingButtonContent({
    loading,
    children,
}: LoadingButtonContentProps) {
    return (
        <>
            {loading && <Loader2 className="mr-2 h-4 w-4 animate-spin" />}
            {!loading && children}
        </>
    );
}
